import React, { useEffect } from "react";
import { FiPlus, FiPrinter, FiDownload } from "react-icons/fi";

import { useNavigate } from "react-router-dom";
import { useLazyGetlabresultsQuery } from "../../State/Api/AddLabReportsApiSlice";

const PatientReports = ({ patientUserUniqueID }) => {
  const [fetchpatientlabresults, { data: patientlabData = {}, isFetching }] =
    useLazyGetlabresultsQuery();
const navigate=useNavigate();
  useEffect(() => {
    if (patientUserUniqueID) {
      fetchpatientlabresults(patientUserUniqueID);
    }
  }, [patientUserUniqueID, fetchpatientlabresults]);

  return (
    <div className="mt-2 space-y-4">
      {/* Header */}
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold mb-2 tracking-tight">
              Lab Results
            </h2>
            <div className="text-sm text-gray-500">
              View all laboratory test results.
            </div>
          </div>
          {/* <button onClick={()=>navigate("/AddPatientReports")} className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] h-10 px-4 py-2 gradient-button">
            <FiPlus className="h-4 w-4" /> Order New Test
          </button> */}
        </div>

        {/* Lab Report Table */}
        <div className="p-4 overflow-x-auto">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Report Type
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Test Names
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Report Date
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Priority
                  </th>
                  {/* <th scope="col" className="px-6 py-3">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {patientlabData?.labReports?.length > 0 ? (
                  patientlabData.labReports.map((report, index) => {
                    const relatedTests =
                      patientlabData?.testRecommendations?.filter(
                        (test) => test.appointmentID === report.appointmentID
                      ) || [];

                    const tests =
                      relatedTests.map((test) => test.testName).join(", ") ||
                      "No Tests";
                    const priorities =
                      relatedTests.map((test) => test.priority).join(", ") ||
                      "No Priority";

                    return (
                      <tr
                        key={index}
                        className="odd:bg-white even:bg-gray-50 border-b border-gray-200"
                      >
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                          {report.reportType}
                        </td>
                        <td className="px-6 py-4">{tests}</td>
                        <td className="px-6 py-4">
                          {report?.reportDate
                            ? new Date(report.reportDate)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .replace(/ /g, "-")
                            : "N/A"}
                        </td>
                        <td className="px-6 py-4">{priorities}</td>
                        {/* <td className="px-6 py-4">
                          <a
                            href="#"
                            className="font-medium text-blue-600 hover:underline"
                          >
                            Edit
                          </a>
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-4 text-center text-gray-500"
                    >
                      No lab reports available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Buttons */}
          {/* <div className="flex justify-end mt-4 gap-2">
            <button className="inline-flex items-center gap-2 text-sm font-medium border rounded-md px-3 h-9">
              <FiPrinter className="h-4 w-4" /> Print
            </button>
            <button className="inline-flex items-center gap-2 text-sm font-medium border rounded-md px-3 h-9">
              <FiDownload className="h-4 w-4" /> Download
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PatientReports;
